import { gql } from "@apollo/client";

// ============================================
// Fragment 정의
// ============================================

const CUSTOMER_INQUIRY_FRAGMENT = gql`
  fragment customerInquiryData on Inquiry {
    id
    userId
    title
    content
    status
    createdAt
    updatedAt
    closedAt
    replyCount
  }
`;

const CUSTOMER_INQUIRY_REPLY_FRAGMENT = gql`
  fragment customerInquiryReplyData on InquiryReply {
    id
    inquiryId
    authorId
    authorName
    isAdminReply
    content
    createdAt
  }
`;

// ============================================
// Queries (관리자용)
// ============================================

// 전체 문의 목록 조회
export const ADMIN_CUSTOMER_INQUIRIES = gql`
  ${CUSTOMER_INQUIRY_FRAGMENT}
  query AdminInquiries($skip: Int, $take: Int, $filter: InquiryFilterInput) {
    adminInquiries(skip: $skip, take: $take, filter: $filter) {
      data {
        ...customerInquiryData
        user {
          id
          userName
          email
          phoneNo
        }
        replies {
          id
          isAdminReply
        }
      }
      totalCount
    }
  }
`;

// 문의 상세 조회
export const ADMIN_CUSTOMER_INQUIRY = gql`
  ${CUSTOMER_INQUIRY_FRAGMENT}
  ${CUSTOMER_INQUIRY_REPLY_FRAGMENT}
  query AdminInquiry($id: Int!) {
    adminInquiry(id: $id) {
      ...customerInquiryData
      user {
        id
        userName
        email
        phoneNo
      }
      replies {
        ...customerInquiryReplyData
      }
    }
  }
`;

// 실시간 패널용 문의 목록 (replies 포함)
export const ADMIN_CUSTOMER_INQUIRIES_WITH_REPLIES = gql`
  ${CUSTOMER_INQUIRY_FRAGMENT}
  query AdminInquiriesWithReplies($skip: Int, $take: Int, $filter: InquiryFilterInput) {
    adminInquiries(skip: $skip, take: $take, filter: $filter) {
      data {
        ...customerInquiryData
        user {
          id
          userName
        }
        replies {
          id
          isAdminReply
          createdAt
        }
      }
      totalCount
    }
  }
`;

// 문의 통계 (대시보드용)
export const ADMIN_CUSTOMER_INQUIRY_STATS = gql`
  query AdminInquiryStats {
    adminInquiryStats {
      total
      pending
      inProgress
      resolved
      cancelled
    }
  }
`;

// ============================================
// Mutations (관리자용)
// ============================================

// 답변 작성 (상태가 자동으로 IN_PROGRESS로 변경됨)
export const ADMIN_ADD_CUSTOMER_INQUIRY_REPLY = gql`
  ${CUSTOMER_INQUIRY_REPLY_FRAGMENT}
  mutation AdminAddReply($inquiryId: Int!, $content: String!) {
    adminAddReply(inquiryId: $inquiryId, content: $content) {
      success
      message
      reply {
        ...customerInquiryReplyData
      }
    }
  }
`;

// 상태 변경
export const ADMIN_UPDATE_CUSTOMER_INQUIRY_STATUS = gql`
  mutation AdminUpdateStatus($id: Int!, $status: Int!) {
    adminUpdateStatus(id: $id, status: $status) {
      success
      message
      inquiry {
        id
        status
        closedAt
      }
    }
  }
`;

// ============================================
// Subscription (실시간 알림 - 선택사항)
// ============================================

export const SUBSCRIBE_NEW_CUSTOMER_INQUIRIES = gql`
  subscription SubscribeNewInquiries {
    subscribeNewInquiries {
      inquiry {
        id
        userId
        title
        status
        createdAt
        user {
          userName
        }
      }
    }
  }
`;
